import React, { useCallback, useContext, useState } from 'react';
import { SnackbarContext } from 'js/social/contexts';
import { FeedbackModal } from 'js/social/shared/FeedbackModal';
import {
  recordShow,
  recordDismissal,
  recordClickthrough,
} from 'js/utils/dismissibles';

const DISMISSIBLE = 'NewsfeedRatingsSurvey';

export const FeedbackModalWatcher: React.FC = () => {
  const { showSnackbar } = useContext(SnackbarContext);
  const [open, setOpen] = useState(false);
  const [shown, setShown] = useState(false);

  const updateRef = (element: HTMLDivElement) => {
    if (shown || !element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          recordShow(DISMISSIBLE);
          setShown(true);
          setTimeout(() => {
            setOpen(true);
          }, 2500);
          observer.disconnect();
        }
      },
      { threshold: 0.5 },
    );

    observer.observe(element);

    return () => observer.disconnect();
  };

  const handleClose = useCallback(() => {
    recordDismissal(DISMISSIBLE);
    setOpen(false);
  }, []);

  const handleSubmit = useCallback(
    (rating: number) => {
      recordClickthrough(DISMISSIBLE, { rating });
      setOpen(false);
      showSnackbar('Thank you for your feedback!', 'success');
    },
    [showSnackbar],
  );

  return (
    <div ref={updateRef}>
      {open && <FeedbackModal onClose={handleClose} onSubmit={handleSubmit} />}
    </div>
  );
};
